import { makeStyles } from '@material-ui/core'
import React, {useEffect, useState} from 'react'
import {Drawer, Input, Form, Select} from 'antd'
import { CTAButton } from '../../components'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

const {Option} = Select

const UpdateJobScheduler = ({account, visible, close}) => {

    const [error, setError] = useState(null)
    const classes = useStyles()
    const [form] = Form.useForm()
    const data = useData()
    const jobsScheduler = data.jobsScheduler()
    const {promiseInProgress} = usePromiseTracker()

     const updateScheduler = vals => {
        vals['tool'] = account['tool']
        trackPromise(
            jobsScheduler.updateScheduler(vals, account["id"])
                .then(close)
                .catch(err => {
                    if('detail' in err){
                        setError(err.detail)
                    }
                    setError("An error occurred.")
                })
        )
    }

    useEffect(() => {
        if (visible){
            console.log('visible',account)
            form.setFieldsValue({
                'day': account['day'],
                'concurrency_factor': account['concurrency_factor'],
            })

        }
        else
            form.resetFields()
    }, [visible])

    return (
        <Drawer
            visible={visible}
            onClose={close}
            placement="right"
            closable={true}
            width={350}
            title="Update Job Scheduler"
        >
            <Form
                layout="vertical"
                onFinish={updateScheduler}
                form={form}
            >
                <Form.Item label="Day" name="day" rules={[{required: true, message: 'Day is required'}]}>
                    <Select>
                        <Option value="Monday">Monday</Option>
                        <Option value="Tuesday">Tuesday</Option>
                        <Option value="Wednesday">Wednesday</Option>
                        <Option value="Thursday">Thursday</Option>
                        <Option value="Friday">Friday</Option>
                        <Option value="Saturday">Saturday</Option>
                        <Option value="Sunday">Sunday</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="Tool" name="tool">
                    <Input disabled value={account["tool_name"]}/><span></span>
                </Form.Item>
                <Form.Item label="Concurrency Factor" name="concurrency_factor" rules={[{required: true, message: 'Concurrency Factor is required'}]}>
                    <Input />
                </Form.Item>

                <Form.Item>
                    <CTAButton loading={promiseInProgress} type="submit"><>Submit</></CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item>
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }

            </Form>
        </Drawer>
    )
}
UpdateJobScheduler.propTypes = {
    account: PropTypes.object,
    visible: PropTypes.bool,
    close: PropTypes.func,
}

export default UpdateJobScheduler
